import { styled, Tooltip } from "@mui/material";

export const MovementsGrid = styled("div")(() => ({
  padding: "24px 32px",
  display: "flex",
  flexDirection: "row",
  "& > div": {
    width: "100%",
  },
}));

export const PrintContainer = styled(Tooltip)(() => ({
  display: "flex",
  marginRight: "10px",
}));
